<!-- Loading bar -->
<base-loading-bar></base-loading-bar>

<mat-sidenav-container class="h-[100dvh] w-full">
  <!-- You can apply fixedInViewport to the mat-sidenav to keep it fixed when scrolling. -->
  <mat-sidenav
    class="border-outline-variant! w-[288px]! border-r"
    [attr.role]="isScreenSmall ? 'dialog' : 'navigation'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [opened]="isScreenSmall === false"
  >
    <div class="flex h-full flex-col">
      <mat-toolbar class="flex flex-row">
        <div class="flex w-full justify-center">
          <mat-icon class="size-1/2!" svgIcon="logo"></mat-icon>
        </div>

        @if (isScreenSmall) {
          <button mat-icon-button aria-label="Toggle sidenav" (click)="toggleSidenav()">
            <mat-icon>menu_opened</mat-icon>
          </button>
        }
      </mat-toolbar>
      <app-navigation-items></app-navigation-items>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="flex h-full w-full min-w-0 flex-auto flex-col">
      <!-- Header -->
      <app-navbar (toggleSidenav)="toggleSidenav()"></app-navbar>

      <!-- Content -->
      <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
          <router-outlet></router-outlet>
        }
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
